import { createAsyncThunk } from "@reduxjs/toolkit";

import { getBillingAlertRequest } from "Api/organizations/billingAlert/getBillingAlert.request";
import { getNewBillingSystemError } from "Hooks/billingSystem/getNewBillingSystemError";
import logger from "Libs/logger";
import { organizationByDescriptionIdSelector } from "Reducers/organization/organization";

import type { BillingAlert } from "..";
import type { AsyncThunkOptionType } from "Reducers/types";

export const getBillingAlert = createAsyncThunk<
  BillingAlert,
  { organizationId: string },
  AsyncThunkOptionType
>(
  "app/organization/get_billing_alert",
  async ({ organizationId }, { rejectWithValue, getState }) => {
    try {
      const organization = organizationByDescriptionIdSelector(getState(), {
        organizationDescriptionId: organizationId
      });

      if (!organization) {
        return rejectWithValue("Organization does not exist");
      }

      const billingAlert = await getBillingAlertRequest(organization?.id);

      return billingAlert;
    } catch (err: unknown) {
      logger(err, {
        action: "get_billing_alert",
        organizationId
      });

      return rejectWithValue(
        getNewBillingSystemError(err) ?? "An error has occurred"
      );
    }
  }
);
